import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionIdFragment } from 'graphql/surface-node/fragments/surface-node-fragment';

export const deleteSurfaceNodeMutation = gql`
  mutation deleteSurfaceNode($id: ID!) {
    deleteSurfaceNode(id: $id) {
      data {
        deletedSurfaceNode {
          ...surfaceNodeUnionId
        }
        references {
          ...surfaceNodeUnionId
        }
      }
      error
      success
    }
  }
  ${surfaceUnionIdFragment}
`;

export default mutation(deleteSurfaceNodeMutation);
